import * as React from "react";
import { Grid, useMediaQuery } from "@mui/material";
import PhaseNavigationPanel from "./components/main/phase_navigation_panel";
import PhaseDetailsPanel from "./components/main/phase_details_panel";
import { CommissioningStateContext } from "./components/hooks/use_commissioning_state_changes";
import { useContext } from "react";
import TermsAndConditionsDialog from "../../../../components/dialogs/terms_and_conditions_dialog";
import useBackend from "../../../../hooks/use_backend";

export default function CommissioningTab({ required_privilege }) {
  const isMobile = useMediaQuery("(max-width:800px)");
  const { commissioningState, termsDialogOpen, termsDialogData, handleTermsAccept, handleTermsDecline } =
    useContext(CommissioningStateContext);
  const backend = useBackend();

  return commissioningState ? (
    <>
      <Grid
        container
        direction={isMobile ? "column" : "row"}
        width="100%"
        height="100%"
        spacing={2}
        padding={2}
        maxWidth="xl"
      >
        <PhaseNavigationPanel required_privilege={required_privilege} />
        <PhaseDetailsPanel required_privilege={required_privilege} />
      </Grid>

      {/* Terms and Conditions Dialog for commissioning */}
      {termsDialogOpen && termsDialogData && (
        <TermsAndConditionsDialog
          open={termsDialogOpen}
          termsData={termsDialogData}
          backend={backend}
          onAccept={handleTermsAccept}
          onDecline={handleTermsDecline}
          type="commissioning"
        />
      )}
    </>
  ) : (
    <Grid
      container
      direction={isMobile ? "column" : "row"}
      width="100%"
      height="100%"
      spacing={2}
      padding={2}
      maxWidth="xl"
    >
      <div>Error loading data</div>
    </Grid>
  );
}
